export const acceptedFileFormats = {
  types: [
    'text/csv',
    'application/vnd.ms-excel',
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  ],
  extensions: ['.csv', '.xls', '.xlsx'],
}